import {
    ActionReducerMap,
    MetaReducer
  } from '@ngrx/store';
import { environment } from 'src/environments/environment';
import * as fromWorkspace from './workspace';

export interface AppState {
    workspace: fromWorkspace.WorkspaceState;
  }

export const reducers: ActionReducerMap<AppState> = {
    workspace: fromWorkspace.reducer,
  };


export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [] : [];
